<template lang="pug">
    v-container(class="fill-height pa-0 ma-0" fluid grid-list-sm)
        v-layout(row)
            v-flex(md4 lg3 class="white" tag="perfect-scrollbar" v-if="drawer").navigator.hidden-sm-and-down
                navigator(:favorite-items="favoriteItems"
                    :all-items="allItems"
                    :pin-items="pinItems"
                    :current-calendar-id="currentSheetId"
                    :current-calendar="currentSheet"
                    @calendar="onSelectSheet"
                    @fav="onToggleFav"
                    @pin="onTogglePin"
                    @subscribe="onToggleSubscribe")
            v-flex(grow)
                v-overlay(:value="loading || favToggling || pinToggling || showOverlay || fileUploading || subscribeToggling")
                    v-progress-circular(indeterminate size="64")
                #sheet-window(:class="{'fill-height': !loading && loadPassed}")
                    v-layout(column :fill-height="!loading && loadPassed")
                        v-app-bar(color="header" dense :flat="false" dark height="50").subHeaderTextColor--text
                            v-app-bar-nav-icon(@click="drawer=!drawer" color="subHeaderTextColor")
                            v-toolbar-title {{currentSheetId && currentSheet ? currentSheet.title : $t('pages.sheet.title')}}
                            v-spacer
                            v-btn(icon @click="rightPanel=!rightPanel" color="subHeaderTextColor")
                                v-icon mdi-dots-vertical
                        template(v-if="!(currentSheetId && currentSheet)")
                            v-layout(column fill-height justify-center align-center).grey--text
                                v-icon(size="150" color="grey") {{icons.sheet}}
                                .headline.font-weight-light Please Select Sheet
                                .headline.font-weight-light For Sheet List on Left Menu :)
                        template(v-else)
                            iframe(:src='docSrc' style='width: 100%; height: 100%; border: 0;' frameborder='0' v-if="!loading && loadPassed")
                            template(v-if="!loading && !loadPassed")
                                v-layout(column fill-height justify-center align-center).grey--text
                                    v-icon(size="150" color="grey") {{icons.sheet}}
                                    .headline.font-weight-light No Sheet :(
            v-flex(md4 lg3 layout column my-0 v-if="rightPanel")
                v-flex(xs12 pa-0 tag="perfect-scrollbar")
                    v-card(tile flat v-show="activeMode==0")
                        v-tabs(background-color="white" color="deep-purple accent-4" height="50" v-model="tab")
                            v-tabs-slider
                            v-tab Search
                            v-tab(@click="onClickChatTab") Chat
                            v-tab-item
                                chat-channel(:channels="channels"
                                    :sub-channels="subChannels"
                                    :rooms="activeRooms"
                                    :histories="histories"
                                    for-operating-sheet

                                    :current-channel-id="currentChannelId"
                                    :current-sub-channel-id="currentSubChannelId"
                                    :current-room-id="currentRoomId"

                                    :current-sub-channel="currentSubChannel"
                                    :current-channel="currentChannel"
                                    :current-room="currentRoom"
                                    :can-delete-room="user.perm_delete_chat_room"

                                    @channel="onSelectChannel"
                                    @sub-channel="onSelectSubChanel"
                                    @room="onSelectRoom"
                                    @history="onSelectRoom"
                                    @find="onFindChatRoom"
                                    @delete-room="onDeleteRoom"
                                    @edit-room="onEditRoom")
                            v-tab-item
                                v-card-text(style="height: 50px" v-if="currentRoomId")
                                    v-icon mdi-chat
                                    span.font-weight-bold.primary--text.ml-2 {{currentRoom ? currentRoom.title : ""}}
                                chat-window(:message.sync="message"
                                    for-operating-sheet
                                    :conversations="sortedConversations"
                                    :current-room="currentRoom"
                                    :current-room-id="currentRoomId"
                                    :socket-id="socketId"
                                    :mention-count="mentionUserIds.length"
                                    :mention-html="mentionUserHtml"
                                    :mention-ids="mentionUserIds"

                                    @image="onShowImage"
                                    @new-message="onNewMessage"
                                    @mention="onMention")
                    v-card(tile flat v-show="activeMode==1").dropfile
                        v-container
                            v-text-field(prepend-icon="mdi-link" :label="$t('pages.sheet.dropFile.pasteLink')"
                                clearable v-model="linkUpload" :disabled="!!fileUpload")
                            .text-center(v-if="true")
                                .font-weight-medium.caption {{$t('pages.sheet.dropFile.or')}}
                            v-file-input(:label="$t('pages.sheet.dropFile.selectFile')" show-size v-model="fileUpload" :disabled="!!linkUpload")
                            v-text-field(:label="$t('pages.sheet.dropFile.newName')" counter="180" v-model="newFileNameUpload")
                            v-hover(v-slot:default="{ hover }")
                                v-alert(
                                    class="py-2 mt-2"
                                    :color="targetFolder ? 'header' : 'error'"
                                    border="left"
                                    elevation="1"
                                    colored-border
                                    icon="mdi-folder"
                                )
                                    v-layout(column)
                                        .caption {{$t('pages.sheet.dropFile.targetFolderLabel')}}
                                        .subheading(v-if="targetFolder") {{targetFolder.name}}
                                        .subheading(v-else) {{$t('pages.sheet.dropFile.invalidTargetFolder')}}
                                    v-scale-transition
                                        div(v-if="hover && targetFolder" class="d-flex transition-fast-in-fast-out header darken-2 v-card--reveal title font-weight-bold white--text"
                                            style="height: 100%;left: 0;border-radius: 4px" v-ripple @click="onGoToFolder") {{$t('pages.sheet.dropFile.openFolder')}}
                            v-btn(block dark color="primary" rounded @click="showFolderPicker")
                                v-icon(left) mdi-folder-open
                                span {{$t('pages.sheet.dropFile.selectTargetFolder')}}
                            v-checkbox(:label="$t('pages.sheet.dropFile.notification')" v-model="notifyUpload")
                            v-row.mx-2
                                v-btn(@click="clearUpload" color="grey" depressed :disabled="!uploadIsValid").px-3.white--text
                                    v-icon(left dark) mdi-cancel
                                    | {{$t('general.cancel')}}
                                v-spacer
                                v-btn(@click="submitUpload" color="primary" depressed :disabled="!uploadIsValid").px-3
                                    v-icon(left dark) mdi-check
                                    | {{$t('general.save')}}
                            v-col.mt-2(v-if="uploadedFilesSorted.length > 0")
                                .subtitle-2 {{$t('pages.sheet.dropFile.uploadedFiles')}}
                                v-divider.my-2
                                template(v-if="false")
                                    .subtitle-2(v-for="file in uploadedFilesSorted") {{file.url}}
                                template(v-if="true")
                                    v-list(dense)
                                        v-list-item(v-for="file in uploadedFilesSorted" :key="file.id" @click="onClickUploadedFile(file)")
                                            v-list-item-content
                                                v-list-item-title {{file.name}}
                                                v-list-item-subtitle {{file.url}}
                v-bottom-navigation(color="white" background-color="primary" shift height=50 v-model="activeMode")
                    v-btn
                        span Chat
                        v-icon mdi-chat
                    v-btn
                        span Drop File
                        v-icon mdi-file
        image-viewer(ref="refImageViewer" @download="onDownloadImage")
        edit-dialog(ref="refEditDialog" :socket-id="socketId" @saved="onNewRoomSaved" @wrong="onSomethingWrong")
        edit-dialog2(ref="refEditDialog2" :socket-id="socketId" @saved="onNewRoomSaved" @wrong="onSomethingWrong")
        rename-dialog(ref="refRenameDialog" @save="onSaveRename")
        chat-room-finder(ref="refChatRoomFinder" @new="onNewChatRoom" @select="onSelectFromFinder" @wrong="onSomethingWrong")
        mention-dialog(ref="refMentionDialog")
        folder-picker-dialog(ref="refFolderPickerDialog" :title="$t('pages.sheet.dropFile.selectTargetFolder')" @submit="onSelectFolder")
        get-link-dialog(ref="refGetLinkDialog")
</template>

<script>
import chat from "../mixins/chat";
import auth from "../mixins/auth";
import general from "../mixins/general";
import Navigator from "../components/operating-sheet/Navigator";
import { get, call, sync } from "vuex-pathify";
import ChatChannel from "../components/chat/ChatChannel";
import ImageViewer from "../components/core/ImageViewer";
import echo from "../mixins/echo";
import ChatWindow from "../components/chat/ChatWindowForSheet";

import ChatRoomFinder from "../components/chat/ChatRoomFinder";
import EditDialog from "../components/chat/EditDialog";
import EditDialog2 from "../components/chat/EditDialog2";
import RenameDialog from "../components/chat/RenameDialog";
import useEventBus from "../mixins/useEventBus";
import { Pipes } from "../event";
import MentionDialog from "../components/chat/MentionDialog";
import FolderPickerDialog from "../components/operating-sheet/FolderPickerDialog";
import crud from "../mixins/crud";
import { fetchSheetFolder } from "../services";
import GetLinkDialog from "../components/operating-calendar/GetLinkDialog";
import { copyToClipboard, getFileViewerUrlFrom } from "../utils";

export default {
  name: "Sheet",
  mixins: [auth, general, echo, chat, useEventBus, crud],
  components: {
    GetLinkDialog,
    FolderPickerDialog,
    MentionDialog,
    ChatWindow,
    ChatChannel,
    Navigator,
    ImageViewer,
    ChatRoomFinder,
    EditDialog,
    EditDialog2,
    RenameDialog
  },
  data() {
    return {
      //https://docs.google.com/spreadsheets/d/1_hKB-ztnPVC0Cc-cgOCpeRSJamoHNhs2uVo6IP813QE/edit?usp=sharing
      loading: false,
      loadPassed: false,
      tab: 0,

      fileRules: [
        value =>
          !value ||
          value.size < 10000000 ||
          "File size should be less than 10 MB!"
      ],
      imageUrl: null,
      cancelUpload: null
    };
  },
  computed: {
    favoriteItems: get("operationSheet/favoriteItems"),
    allItems: get("operationSheet/allItems"),
    pinItems: get("operationSheet/pinItems"),

    fetching: get("operationSheet/fetching"),
    favToggling: get("operationSheet/favToggling"),
    pinToggling: get("operationSheet/pinToggling"),
    subscribeToggling: get("operationSheet/subscribeToggling"),
    currentSheet: get("operationSheet/currentSheet"),
    currentSheetId: sync("operationSheet/currentSheetId"),
    fromChat: sync("operationSheet/fromChat"),
    drawer: sync("operationSheet/drawer"),
    rightPanel: sync("operationSheet/rightPanel"),
    activeMode: sync("operationSheet/activeMode"),
    targetFolder: sync("operationSheet/targetFolder"),
    linkUpload: sync("operationSheet/linkUpload"),
    fileUpload: sync("operationSheet/fileUpload"),
    notifyUpload: sync("operationSheet/notifyUpload"),
    newFileNameUpload: sync("operationSheet/newFileNameUpload"),
    fileUploading: sync("operationSheet/fileUploading"),
    uploadedFilesSorted: get("operationSheet/uploadedFilesSorted"),
    fromNotify: sync("operationSheet/fromNotify"),
    docSrc() {
      if (this.currentSheetId && this.currentSheet)
        // return `https://docs.google.com/spreadsheets/d/${this.currentSheet.sheet_id}/edit?rm=demo#gid=0`;
        return this.currentSheet.link;
      return null;
    },

    //Chat
    message: sync("operationSheetChat/message"),
    socketId: sync("operationSheetChat/socketId"),
    mentionUserIds: sync("operationSheetChat/mentionUserIds"),
    mentionUserHtml: sync("operationSheetChat/mentionUserHtml"),
    currentChannelId: get("operationSheetChat/currentChannelId"),
    currentSubChannelId: get("operationSheetChat/currentSubChannelId"),
    currentRoomId: get("operationSheetChat/currentRoomId"),
    uploadIsValid() {
      return (
        !!this.targetFolder &&
        (!!this.linkUpload || !!this.fileUpload) &&
        (!this.newFileNameUpload || this.newFileNameUpload.length <= 180)
      );
    }
  },
  watch: {
    fileUpload(value) {
      if (value) {
        this.newFileNameUpload = value.name;
      } else {
        this.newFileNameUpload = "";
      }
    },
    linkUpload(value) {
      if (typeof value === "string") {
        this.newFileNameUpload = value.substring(value.lastIndexOf("/") + 1);
      } else {
        this.newFileNameUpload = "";
      }
    }
  },
  methods: {
    fetchData: call("operationSheet/fetchData"),
    toggleFavorite: call("operationSheet/toggleFavorite"),
    togglePin: call("operationSheet/togglePin"),
    toggleSubscribe: call("operationSheet/toggleSubscribe"),
    getShareLink: call("operationCalendar/getShareLink"),
    openSheet(sheet) {
      this.loading = true;
      this.loadPassed = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
      if (
        !sheet ||
        (this.targetFolder &&
          sheet.calendar.id !== this.targetFolder.calendar_id)
      ) {
        this.targetFolder = null;
      }
      if (sheet) {
        this.$store.dispatch("notification/markAsReadSheet", sheet.id);
      }
    },
    async onSelectSheet(sheet) {
      this.currentSheetId = sheet.id;
      this.openSheet(sheet);
      // TODO: OPEN CHANNEL
      await this.fetchAllChannels();
      const idx = this.channels.findIndex(c => c.id === sheet.calendar.id);
      if (idx > -1) {
        await this.onSelectChannel(this.channels[idx]);
      }
    },
    onToggleFav(sheet) {
      this.toggleFavorite(sheet.id).finally(() => {
        this.loadData(false);
      });
    },
    onTogglePin(sheet) {
      this.togglePin(sheet.id).finally(() => {
        this.loadData(false);
      });
    },
    onToggleSubscribe(sheet) {
      this.toggleSubscribe(sheet.id).finally(() => {
        this.loadData(false);
      });
    },
    async loadData(selectPin = true, forceId = 0) {
      await this.fetchData(undefined).then(items => {
        // if (items.length === 1) {
        //     this.onSelectCalendar(items[0])
        // }
        //
        if (selectPin && this.pinItems.length) {
          this.onSelectSheet(this.pinItems[0]);
        } else {
          const idx = items.findIndex(
            i => i.id === forceId || i.id === this.currentSheetId
          );
          if (idx > -1) {
            this.onSelectSheet(items[idx]);
          }
        }
      });
    },

    // Chat operationSheetChat
    changeChannelId: call("operationSheetChat/changeChannelId"),
    changeSubChannelId: call("operationSheetChat/changeSubChannelId"),
    changeRoomId: call("operationSheetChat/changeCurrentRoomId"),
    setOnlineUsersIds: call("users/setOnlineUsersIds"),
    switchToChatTab() {
      this.tab = 1;
    },
    onCanFillConversation() {
      return this.activeMode === 0 && this.tab === 1;
    },
    async onClickChatTab() {
      if (
        this.currentChannelId &&
        this.currentSubChannelId &&
        this.currentRoomId &&
        this.currentRoom
      ) {
        await this.fetchAllChannels();
      }
    },
    async showFolderPicker() {
      const canUpload = await this.$store
        .dispatch("auth/fetchUser")
        .then(user => {
          return user.perm_drop_file_at_sheet;
        });
      if (canUpload)
        this.$refs["refFolderPickerDialog"].show(this.currentSheet.calendar.id);
      else
        this.$toasted.error(this.$t("general.permissionFailed.dropFile"), {
          icon: "mood_bad"
        });
    },
    onSelectFolder(folder) {
      this.targetFolder = folder;
    },
    clearUpload() {
      this.targetFolder = null;
      this.linkUpload = "";
      this.fileUpload = null;
      this.notifyUpload = false;
      this.newFileNameUpload = "";
    },
    async onGoToFolder() {
      if (this.targetFolder) {
        await fetchSheetFolder(this.targetFolder.id)
          .then(async data => {
            if (data.accessible) {
              await this.$store.set("operationCalendar/fromChat", data);
              await this.$router.push({ name: "calendar.index" });
            } else {
              this.$toasted.error(
                this.$t("general.permissionFailed.createReadFolder"),
                {
                  icon: "mood_bad",
                  className: "error"
                }
              );
            }
          })
          .catch(err => {
            this.$toasted.error(this.$t("general.somethingWrong"), {
              icon: "mood_bad",
              className: "error"
            });
          });
      }
    },
    async submitUpload() {
      const canUpload = await this.$store
        .dispatch("auth/fetchUser")
        .then(user => {
          return user.perm_drop_file_at_sheet;
        });

      if (
        canUpload &&
        this.currentSheetId &&
        (this.fileUpload || this.linkUpload)
      ) {
        const body = new FormData();
        body.append("folder_id", this.targetFolder.id);
        body.append("sheet_id", this.currentSheetId);
        body.append("notify", this.notifyUpload ? "1" : "0");

        if (this.linkUpload) {
          body.append("link", this.linkUpload);
          body.append("file_name", this.newFileNameUpload);
        } else if (this.fileUpload) {
          body.append(
            `files[0]`,
            this.fileUpload,
            this.newFileNameUpload
              ? this.newFileNameUpload
              : this.fileUpload.name
          );
        }

        let self = this;

        this.fileUploading = true;
        const uploadedFile = await this.axios
          .post(`me/calendars/upload`, body, {
            cancelToken: new this.axios.CancelToken(function executor(c) {
              self.cancelUpload = c;
            })
          })
          .then(response => {
            this.fileUploading = false;
            // this.$toasted.info("File Uploaded");
            return Array.isArray(response.data.data) &&
              response.data.data.length
              ? response.data.data[0]
              : null;
          })
          .catch(error => {
            this.fileUploading = false;
            if (this.axios.isCancel(error)) {
              this.$toasted.error(error.message, { icon: "mood_bad" });
            } else {
              this.saveErrorHandler(error);
            }
          })
          .finally(() => (this.cancelUpload = null));

        if (!uploadedFile) return;
        this.linkUpload = "";
        this.fileUpload = null;
        this.notifyUpload = false;
        this.newFileNameUpload = "";

        this.fileUploading = true;
        const link = await this.getShareLink(uploadedFile.id)
          .then(data => {
            this.fileUploading = false;
            return data;
          })
          .catch(err => {
            this.fileUploading = false;
            this.$toasted.error(this.$t("general.somethingWrong"), {
              icon: "mood_bad"
            });
          });
        if (!link) return;
        const f = { ...link, url: getFileViewerUrlFrom(link), ...uploadedFile };
        await this.$store.dispatch("operationSheet/pushUploadedFile", f);
        this.onClickUploadedFile(f);
      } else
        this.$toasted.error(this.$t("general.permissionFailed.dropFile"), {
          icon: "mood_bad"
        });
    },
    onClickUploadedFile(file) {
      copyToClipboard(file.url, this);
    }
  },

  async mounted() {
    if (this.fromChat) {
      this.fetchData()
        .then(async items => {
          this.activeMode = 0;
          await this.changeChannelId(this.fromChat.channelId);
          await this.changeSubChannelId(this.fromChat.subChannelId);
          await this.changeRoomId(this.fromChat.roomId);
          const idx = items.findIndex(s => s.id === this.fromChat.sheetId);
          if (idx > -1) {
            this.onSelectSheet(items[idx]);
            // console.log("select sheet :", items[idx]);
            // console.log("data :", this.fromChat.data);
          } else if (this.pinItems.length) {
            this.onSelectSheet(this.pinItems[0]);
          }
        })
        .finally(() => {
          this.fromChat = null;
        });
    } else if (this.fromNotify) {
      await this.loadData(false, this.fromNotify.sheet_id);
      this.fromNotify = null;
    } else if (!this.fetching) {
      this.loadData();
    }
  },

  beforeDestroy() {
    this.fromNotify = null;
    if (typeof this.cancelUpload === "function") {
      this.cancelUpload("Uploading canceled");
      console.log("Uploading canceled");
    }
  },

  created() {
    this.eventListeners.push({
      name: Pipes.notify.openChatRoomInSheet,
      callback: async data => {
        await this.$store.set(
          "operationSheetChat/currentChannelId",
          data.channel_id
        );
        await this.$store.set(
          "operationSheetChat/currentSubChannelId",
          data.sub_channel_id
        );
        await this.$store.set("operationSheetChat/currentRoomId", data.room_id);
        await this.fetchAllChannels();
      }
    });

    this.eventListeners.push({
      name: Pipes.notify.openSheet,
      callback: async data => {
        await this.loadData(false, data.sheet_id);
      }
    });
  }
};
</script>

<style scoped lang="scss">
.navigator {
  height: calc(100vh - 65px);
}

.dropfile {
  overflow-y: auto;
  /*height: calc(100vh - 65px - 60px - 108px);*/
  height: calc(100vh - 65px - 60px);
  border-radius: 0;
}

.sheet-window {
  overflow-y: auto;
  height: calc(100vh - 65px - 50px);
  border-radius: 0;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
  cursor: pointer;
}
</style>
